import React from "react";
import { useNavigate } from "react-router-dom";
import Location from "../../features/rapidstor/entities/Location";
import Breadcrumb from "./Breadcrumb";
import { Stack } from "react-bootstrap";
import classes from "./Breadcrumbs.module.scss";
// import iconPinOutline from "../../assets/icon-pin-outline.svg";
// import iconHouseOutline from "../../assets/icon-house-outline.svg";
// import iconBusinessOutline from "../../assets/icon-business-outline.svg";
// import iconVehicleOutline from "../../assets/icon-vehicle-outline.svg";
import { ReactComponent as IconPinOutline } from "../../assets/icon-pin-outline.svg";
import { ReactComponent as IconHouseOutline } from "../../assets/icon-house-outline.svg";
import { ReactComponent as IconBusinessOutline } from "../../assets/icon-business-outline.svg";
import { ReactComponent as IconVehicleOutline } from "../../assets/icon-vehicle-outline.svg";
import { resetQuestionnaire, selectResponses } from "../../store/questionnaireSlice";
import store from "../../store";
import { useSelector } from "react-redux";
import { options } from "../../services/rapidstor";

interface Props {
  location: Location | null;
}

function Breadcrumbs({ location }: Props) {
  const navigate = useNavigate();
  const responses = useSelector(selectResponses);

  const locationCrumb = (
    <Breadcrumb
      icon={<IconPinOutline className={classes.icon} />}
      onEditClick={() => navigate("/")}
    >
      {location
        ? `${!options.enabledLocations.includes("L005") ? "KeepSafe" : ""} ${
            location.name
          }`
        : "No location selected"}
    </Breadcrumb>
  );

  let secondCrumb;
  if (typeof responses?.storageType === "string") {
    const TypeIcon = {
      "Personal Storage": IconHouseOutline,
      "Business Storage": IconBusinessOutline,
      "Vehicle/RV Storage": IconVehicleOutline,
      "All Units": IconHouseOutline,
    }[responses.storageType];

    const onEditClick = () => {
      store.dispatch(resetQuestionnaire());

      if (location) {
        navigate(`/locations/${location.slug}`);
      }
    };

    if (TypeIcon) {
      secondCrumb = (
        <Breadcrumb
          icon={<TypeIcon className={classes.icon} />}
          onEditClick={onEditClick}
        >
          {responses?.storageType}
        </Breadcrumb>
      );
    }
  }

  return (
    <Stack gap={{ xs: 1, lg: 3 }} className={classes.breadcrumbs}>
      {locationCrumb}
      {secondCrumb ?? secondCrumb}
    </Stack>
  );
}

export default Breadcrumbs;
